// TODO: web-pages의 도메인과 중복 제거
export enum RecruitingPeriodType {
  Occasional = 'OCCASIONAL', // 상시 채용
  Periodic = 'PERIODIC', // 기간 채용
}
